// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-name {
  font-size: 15px;
  font-weight: 900;
  line-height: 1;
  color: #003da5;
  padding: 0 15px 0px 13px;
  text-decoration: none;
}

.ProjectPlanBreadCrum ul {
  padding: 0;
}

.AccodianBtn {
  position: absolute;
  top: 15px;
  right: 350px;
}

.projectPlanAccordianScorll {
  height: 100%;
  overflow-x: auto;
  top: 0;
  z-index: 2;
}

.invertedIcon {
  transform: rotate(180deg);
  cursor: pointer;
}

.nonInvertedIcon {
  cursor: pointer;
}

.subNav .nav {
  padding-left: 13px;
  border-color: #003da5;
}
.subNav .nav-link {
  color: rgb(172, 172, 172);
}
.subNav .nav-link.active {
  color: rgb(0, 61, 165);
  border-width: 1px 1px 0 1px;
  border-color: #003da5 #003da5 #ffffff #003da5;
}

.accordion {
  padding: 0;
  margin: 0px -15px;
  border: 0;
  border-radius: 0;
  position: relative;
}
.accordion .accordion-item {
  border-radius: 0;
  border: 0;
  margin-bottom: 5px;
}
.accordion .accordion-item .accordion-header {
  background-color: #edf4fa;
}
.accordion .accordion-item .accordion-body {
  padding: 0;
}
.accordion .accordion-button {
  box-shadow: none !important;
  outline: none !important;
  border-radius: 0 !important;
  padding-left: 30px;
  font-size: 14px;
  color: #003da5;
  background-color: #edf4fa !important;
  width: fit-content;
  margin-right: 2px;
}
.accordion .accordion-button::after {
  margin-left: 5px;
}
.accordion .accordion-button:not(.collapsed) {
  background: #edf4fa;
  color: #003da5;
}

.tabular-add-project {
  padding: 8px 0 0 15px;
  overflow-y: scroll;
}

.p-breadcrumb ul .pi-chevron-right:nth-child(3) {
  color: #003da5;
}

.p-breadcrumb ul li .p-menuitem-link {
  box-shadow: none !important;
  outline: none !important;
}

.projectPlanButtons {
  display: flex;
  justify-content: flex-end;
  margin-right: 11px;
  margin-left: 28px;
}
.projectPlanButtons label {
  padding: 8px 18px;
}
.projectPlanButtons label:first-child {
  border-radius: 20px 0 0 20px;
}
.projectPlanButtons label:last-child {
  border-radius: 0 20px 20px 0;
}
.projectPlanButtons .btn {
  background-color: #ffffff;
  color: #003da5;
  border-color: #003da5 !important;
}
.projectPlanButtons .btn:hover {
  background-color: #003da5;
  color: #ffffff;
}

.ganttChartTabular {
  background-color: #003da5 !important;
  color: #ffffff !important;
}

.ActionsDropdown {
  background-color: #003da5;
}

#projectActions {
  height: 32px;
  width: 98.4px;
  border-radius: 20px !important;
  padding: 10px 18px 10px 18px;
  margin-right: 11px;
  background-color: #ffffff !important;
  color: #003da5;
  line-height: 12px;
}

#projectActions:hover {
  background-color: #003da5 !important;
  color: #ffffff;
}

.projectSetupParent {
  height: 100%;
  background: rgb(255, 255, 255);
  border-radius: 24px;
  margin-left: 2px;
  padding-bottom: 5px;
  position: relative;
}
.projectSetupParent.project-setup-wrapper {
  position: relative;
}
.projectSetupParent.project-setup-wrapper .tabular-add-project {
  overflow: hidden;
}
.projectSetupParent.project-setup-wrapper .tabular-add-project form .p-autocomplete {
  width: 100%;
}
.projectSetupParent.project-plan-wrapper {
  padding-bottom: 25px;
}
.projectSetupParent.project-plan-wrapper .tab-content {
  overflow: initial;
  padding: 0;
}
.projectSetupParent.project-plan-wrapper .manage-dependency-btn {
  margin-right: 5px;
}
.projectSetupParent .form-buttons {
  padding: 10px;
  position: absolute;
  background: white;
  text-align: right;
  width: 100%;
  left: 0;
}

.breadCrumbParent {
  padding-top: 8px;
  padding-left: 23px;
  padding-bottom: 8px;
  padding-right: 10px !important;
}
.breadCrumbParent nav {
  margin-left: 5px;
}

.breadCrumbParent .dropdown-menu.show {
  border: 0.5px solid #003da5 !important;
  border-radius: 8px;
  margin-top: 8px !important;
  box-shadow: 0 6px 16px 0 rgba(89, 89, 89, 0.24);
}
.breadCrumbParent .show .dropdown-toggle::after {
  transform: rotate(180deg);
}

.projectPlanName {
  padding-bottom: 5px;
}

.dropdownItemPaddingLeft {
  padding-left: 8px;
  border-bottom: none;
}

.dropdownItemColor {
  color: #d37302;
}

.dropdownItemColor1 {
  color: #ff0000;
}

.dropdownItemColor2 {
  color: #003da5;
}

.content-layout .actionsPaddingForUBD {
  padding: 0;
}
.content-layout .actionsPaddingForUBD .p-breadcrumb ul {
  padding: 8px 0;
}

.projectPlanButtonsParent {
  text-align: right;
}

.displayFlex {
  display: flex;
  line-height: 15px;
}

.tab-content {
  height: 100%;
  overflow: hidden;
  position: relative;
  padding-bottom: 20px;
}
.tab-content .nav-link {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
}

.tab-content > .active {
  padding: 10px 20px;
  display: contents !important;
}

.nav-tabs a {
  border: 0 !important;
  background-color: transparent !important;
}

.nav-tabs li.active {
  border-bottom: 2px solid #5453d2;
}

.nav-tabs li {
  border-bottom: 2px solid transparent;
}

.nav-tabs li a {
  width: 100%;
  text-align: center;
  text-decoration: none;
}

ul.nav.nav-tabs {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  overflow: hidden;
}

.nav-tabs li {
  min-width: 12%;
  display: flex;
  align-items: flex-start;
  margin: 0 !important;
  padding: 0 5px;
}

.tabs-wrapper {
  flex: 1 1;
}
.tabs-wrapper .nav-tabs li.active {
  border-bottom: 2.5px solid rgb(0, 61, 165);
}
.tabs-wrapper .nav-tabs li > a {
  color: rgb(172, 172, 172);
  font-weight: 500;
  font-size: 14px;
  line-height: 17.07px;
}
.tabs-wrapper .nav-tabs li.active > a {
  color: rgb(0, 61, 165);
}

span.left,
span.right {
  position: absolute;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #5453d2;
  border-radius: 50%;
  left: -50px;
  top: 8px;
  cursor: pointer;
  color: #ffffff;
}

span.right {
  right: -50px;
  left: unset;
}

.scroller-btn.inactive {
  opacity: 0.3;
  pointer-events: none;
}

.piChevronRightMargin {
  margin-left: 9.5px;
  margin-right: 9.81px;
}

.pi-chevron-right {
  margin-left: 9.5px;
  margin-right: 9.81px;
}

.tabComponent {
  display: flex;
  align-items: center;
}
.tabComponent li a {
  cursor: pointer;
}
.tabComponent .actionButtonsForTabComponent {
  margin-right: 10px;
}

.filterPopoverWidth {
  width: fit-content;
  max-width: 32%;
}

.filterPopoverWidth .p-multiselect-header .p-checkbox {
  margin-right: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/ProjectSetup/index.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EAEA,cAAA;EAGA,wBAAA;EACA,qBAAA;AAJF;;AAQE;EACE,UAAA;AALJ;;AAUA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;AAPF;;AAUA;EACE,YAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAPF;;AAUA;EACE,yBAAA;EACA,eAAA;AAPF;;AASA;EACE,eAAA;AANF;;AAYE;EACE,kBAAA;EACA,qBAAA;AATJ;AAYE;EACE,yBAAA;AAVJ;AAcE;EACE,sBAAA;EACA,2BAAA;EACA,6CAAA;AAZJ;;AAgBA;EACE,UAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAbF;AAgBE;EACE,gBAAA;EACA,SAAA;EACA,kBAAA;AAdJ;AAgBI;EACE,yBAAA;AAdN;AAiBI;EACE,UAAA;AAfN;AAwBE;EACE,2BAAA;EACA,wBAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AAtBJ;AAwBI;EACE,gBAAA;AAtBN;AA0BE;EACE,mBAAA;EACA,cAAA;AAxBJ;;AA4BA;EAEE,qBAAA;EACA,kBAAA;AA1BF;;AA8BA;EACE,cAAA;AA3BF;;AA8BA;EACE,2BAAA;EACA,wBAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AA3BF;AA6BE;EACE,iBAAA;AA3BJ;AA6BI;EACE,4BAAA;AA3BN;AA8BI;EACE,4BAAA;AA5BN;AAkDE;EACE,yBAAA;EACA,cAAA;EACA,gCAAA;AAhDJ;AAmDE;EACE,yBAAA;EACA,cAAA;AAjDJ;;AAqDA;EACE,oCAAA;EACA,yBAAA;AAlDF;;AAqDA;EACE,yBAAA;AAlDF;;AAqDA;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,4BAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,iBAAA;AAlDF;;AAqDA;EACE,oCAAA;EACA,cAAA;AAlDF;;AAqDA;EACE,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAlDF;AAoDE;EAEE,kBAAA;AAnDJ;AAqDI;EACE,gBAAA;AAnDN;AA0DQ;EACE,WAAA;AAxDV;AA8DE;EACE,oBAAA;AA5DJ;AA8DI;EAEE,iBAAA;EACA,UAAA;AA7DN;AAgEI;EACE,iBAAA;AA9DN;AAkEE;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,OAAA;AAhEJ;;AAqEA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AAlEF;AAuEE;EACE,gBAAA;AArEJ;;AA0EE;EACE,sCAAA;EACA,kBAAA;EACA,0BAAA;EACA,+CAAA;AAvEJ;AA2EI;EACE,yBAAA;AAzEN;;AA8EA;EACE,mBAAA;AA3EF;;AA8EA;EACE,iBAAA;EACA,mBAAA;AA3EF;;AA8EA;EACE,cAAA;AA3EF;;AA8EA;EACE,cAAA;AA3EF;;AA8EA;EACE,cAAA;AA3EF;;AA8EA;EACE,UAAA;AA3EF;AA6EE;EACE,cAAA;AA3EJ;;AA+EA;EACE,iBAAA;AA5EF;;AA+EA;EACE,aAAA;EACA,iBAAA;AA5EF;;AAgFA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AA7EF;AA+EE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;AA7EJ;;AAiFA;EACE,kBAAA;EACA,4BAAA;AA9EF;;AAiFA;EACE,oBAAA;EACA,wCAAA;AA9EF;;AAiFA;EACE,gCAAA;AA9EF;;AAiFA;EACE,oCAAA;AA9EF;;AAiFA;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;AA9EF;;AAiFA;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,gBAAA;AA9EF;;AAiFA;EAEE,cAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,cAAA;AA/EF;;AAkFA;EACE,SAAA;AA/EF;AAiFE;EACE,0CAAA;AA/EJ;AAkFE;EACE,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAhFJ;AAmFE;EACE,sBAAA;AAjFJ;;AAqFA;;EAEE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AAlFF;;AAqFA;EACE,YAAA;EACA,WAAA;AAlFF;;AAqFA;EACE,YAAA;EACA,oBAAA;AAlFF;;AAqFA;EACE,kBAAA;EACA,oBAAA;AAlFF;;AAqFA;EACE,kBAAA;EACA,oBAAA;AAlFF;;AAqFA;EACE,aAAA;EACA,mBAAA;AAlFF;AAqFI;EACE,eAAA;AAnFN;AAuFE;EACE,kBAAA;AArFJ;;AAyFA;EACE,kBAAA;EACA,cAAA;AAtFF;;AA0FE;EACE,kBAAA;AAvFJ","sourcesContent":["$width: 100%;\n\n.project-name {\n  font-size: 15px;\n  font-weight: 900;\n  line-height: 1;\n  // line-height: 29px;\n  color: #003da5;\n  // padding: 0 15px 22px 15px;\n  // padding: 0 15px 10px 15px;\n  padding: 0 15px 0px 13px;\n  text-decoration: none;\n}\n\n.ProjectPlanBreadCrum {\n  ul {\n    padding: 0;\n  }\n}\n\n//<----- Accodian Expand all && Collapse All css start ----->//\n.AccodianBtn {\n  position: absolute;\n  top: 15px;\n  right: 350px;\n}\n\n.projectPlanAccordianScorll {\n  height: 100%;\n  overflow-x: auto;\n  top: 0;\n  z-index: 2;\n}\n\n.invertedIcon {\n  transform: rotate(180deg);\n  cursor: pointer;\n}\n.nonInvertedIcon {\n  cursor: pointer;\n}\n\n//<----Accodian Expand all && Collapse All css end ------> //\n\n.subNav {\n  .nav {\n    padding-left: 13px;\n    border-color: #003da5;\n  }\n\n  .nav-link {\n    color: rgba(172, 172, 172, 1);\n    // border-color: #ffffff;\n  }\n\n  .nav-link.active {\n    color: rgba(0, 61, 165, 1);\n    border-width: 1px 1px 0 1px;\n    border-color: #003da5 #003da5 #ffffff #003da5;\n  }\n}\n\n.accordion {\n  padding: 0;\n  margin: 0px -15px;\n  border: 0;\n  border-radius: 0;\n  position: relative;\n\n  //   z-index: 1000000;\n  .accordion-item {\n    border-radius: 0;\n    border: 0;\n    margin-bottom: 5px;\n\n    .accordion-header {\n      background-color: #edf4fa;\n    }\n\n    .accordion-body {\n      padding: 0;\n    }\n\n    // .accordion-body {\n    //   height: 50vh;\n    //   overflow: auto;\n    // }\n  }\n\n  .accordion-button {\n    box-shadow: none !important;\n    outline: none !important;\n    border-radius: 0 !important;\n    padding-left: 30px;\n    font-size: 14px;\n    color: #003da5;\n    background-color: #edf4fa !important;\n    width: fit-content;\n    margin-right: 2px;\n\n    &::after {\n      margin-left: 5px;\n    }\n  }\n\n  .accordion-button:not(.collapsed) {\n    background: #edf4fa;\n    color: #003da5;\n  }\n}\n\n.tabular-add-project {\n  // padding: 8px 0 0 0;\n  padding: 8px 0 0 15px;\n  overflow-y: scroll;\n  //height: 72vh;\n}\n\n.p-breadcrumb ul .pi-chevron-right:nth-child(3) {\n  color: #003da5;\n}\n\n.p-breadcrumb ul li .p-menuitem-link {\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.projectPlanButtons {\n  display: flex;\n  justify-content: flex-end;\n  margin-right: 11px;\n  margin-left: 28px;\n\n  & label {\n    padding: 8px 18px;\n\n    &:first-child {\n      border-radius: 20px 0 0 20px;\n    }\n\n    &:last-child {\n      border-radius: 0 20px 20px 0;\n    }\n  }\n\n  // & label.btn-secondary {\n  //   background-color: #003da5;\n  //   color: #fff;\n  //   &:hover {\n  //     background-color: #003da5;\n  //     color: #fff;\n  //   }\n  // }\n\n  // & label.active {\n  //   background-color: #fff;\n  //   color: #003da5;\n  //   &:hover {\n  //     background-color: #003da5;\n  //     color: #003da5;\n  //   }\n  // }\n\n  .btn {\n    background-color: #ffffff;\n    color: #003da5;\n    border-color: #003da5 !important;\n  }\n\n  .btn:hover {\n    background-color: #003da5;\n    color: #ffffff;\n  }\n}\n\n.ganttChartTabular {\n  background-color: #003da5 !important;\n  color: #ffffff !important;\n}\n\n.ActionsDropdown {\n  background-color: #003da5;\n}\n\n#projectActions {\n  height: 32px;\n  width: 98.4px;\n  border-radius: 20px !important;\n  padding: 10px 18px 10px 18px;\n  margin-right: 11px;\n  background-color: #ffffff !important;\n  color: #003da5;\n  line-height: 12px;\n}\n\n#projectActions:hover {\n  background-color: #003da5 !important;\n  color: #ffffff;\n}\n\n.projectSetupParent {\n  height: 100%;\n  background: rgb(255, 255, 255);\n  border-radius: 24px;\n  margin-left: 2px;\n  padding-bottom: 5px;\n  position: relative;\n\n  &.project-setup-wrapper {\n    // height: 100%;\n    position: relative;\n\n    .tabular-add-project {\n      overflow: hidden;\n\n      form {\n        // height: 100%;\n        // overflow: hidden auto;\n        //padding-bottom: 90px;\n\n        .p-autocomplete {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  &.project-plan-wrapper {\n    padding-bottom: 25px;\n\n    .tab-content {\n      // height: auto;\n      overflow: initial;\n      padding: 0;\n    }\n\n    .manage-dependency-btn {\n      margin-right: 5px;\n    }\n  }\n\n  .form-buttons {\n    padding: 10px;\n    position: absolute;\n    background: white;\n    text-align: right;\n    width: 100%;\n    left: 0;\n    // bottom: 30px;\n  }\n}\n\n.breadCrumbParent {\n  padding-top: 8px;\n  padding-left: 23px;\n  padding-bottom: 8px;\n  padding-right: 10px !important;\n\n  // padding-left: 16px;\n  // border-radius: 24px\n  // width: $width;\n  nav {\n    margin-left: 5px;\n  }\n}\n\n.breadCrumbParent {\n  .dropdown-menu.show {\n    border: 0.5px solid #003da5 !important;\n    border-radius: 8px;\n    margin-top: 8px !important;\n    box-shadow: 0 6px 16px 0 rgba(89, 89, 89, 0.24);\n  }\n\n  .show {\n    .dropdown-toggle::after {\n      transform: rotate(180deg);\n    }\n  }\n}\n\n.projectPlanName {\n  padding-bottom: 5px;\n}\n\n.dropdownItemPaddingLeft {\n  padding-left: 8px;\n  border-bottom: none;\n}\n\n.dropdownItemColor {\n  color: #d37302;\n}\n\n.dropdownItemColor1 {\n  color: #ff0000;\n}\n\n.dropdownItemColor2 {\n  color: #003da5;\n}\n\n.content-layout .actionsPaddingForUBD {\n  padding: 0;\n\n  .p-breadcrumb ul {\n    padding: 8px 0;\n  }\n}\n\n.projectPlanButtonsParent {\n  text-align: right;\n}\n\n.displayFlex {\n  display: flex;\n  line-height: 15px;\n}\n\n// TabsComponent Styles Start\n.tab-content {\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 20px;\n\n  .nav-link {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n  }\n}\n\n.tab-content > .active {\n  padding: 10px 20px;\n  display: contents !important;\n}\n\n.nav-tabs a {\n  border: 0 !important;\n  background-color: transparent !important;\n}\n\n.nav-tabs li.active {\n  border-bottom: 2px solid #5453d2;\n}\n\n.nav-tabs li {\n  border-bottom: 2px solid transparent;\n}\n\n.nav-tabs li a {\n  width: 100%;\n  text-align: center;\n  text-decoration: none;\n}\n\nul.nav.nav-tabs {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  overflow: hidden;\n}\n\n.nav-tabs li {\n  // flex-basis: 90px;\n  min-width: 12%; //tabs equal spacing\n  display: flex;\n  align-items: flex-start;\n  margin: 0 !important;\n  padding: 0 5px;\n}\n\n.tabs-wrapper {\n  flex: 1;\n\n  .nav-tabs li.active {\n    border-bottom: 2.5px solid rgba(0, 61, 165, 1);\n  }\n\n  .nav-tabs li > a {\n    color: rgba(172, 172, 172, 1);\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 17.07px;\n  }\n\n  .nav-tabs li.active > a {\n    color: rgba(0, 61, 165, 1);\n  }\n}\n\nspan.left,\nspan.right {\n  position: absolute;\n  height: 30px;\n  width: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #5453d2;\n  border-radius: 50%;\n  left: -50px;\n  top: 8px;\n  cursor: pointer;\n  color: #ffffff;\n}\n\nspan.right {\n  right: -50px;\n  left: unset;\n}\n\n.scroller-btn.inactive {\n  opacity: 0.3;\n  pointer-events: none;\n}\n\n.piChevronRightMargin {\n  margin-left: 9.5px;\n  margin-right: 9.81px;\n}\n\n.pi-chevron-right {\n  margin-left: 9.5px;\n  margin-right: 9.81px;\n}\n\n.tabComponent {\n  display: flex;\n  align-items: center;\n\n  li {\n    a {\n      cursor: pointer;\n    }\n  }\n\n  .actionButtonsForTabComponent {\n    margin-right: 10px;\n  }\n}\n\n.filterPopoverWidth {\n  width: fit-content;\n  max-width: 32%;\n}\n\n.filterPopoverWidth {\n  .p-multiselect-header .p-checkbox {\n    margin-right: 14px;\n  }\n}\n\n// TabsComponent Styles End\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
